module.exports = __webpack_public_path__ + "static/img/icon-neigou.81f45a5b.svg";